import React, { useCallback } from 'react';
import { Box, Text } from '@common-fe/common-fe';

import { ReportSummaryRowItem, ReportSummarySubsidiaryRow } from './ReportSummary.types';
import ReportSummaryBaseTable from './ReportSummaryBaseTable';

interface Props extends ReportSummarySubsidiaryRow {
  headers: ReportSummaryRowItem[];
  isLastItem?: boolean;
  index?: number;
}

const ReportSummaryBaseSubsidiary: React.FC<Props> = ({
  headers,
  index,
  title,
  rows,
  isLastItem,
  isTotalModeLastItem,
  isPreviewMode,
}) => {
  const getWrapper = useCallback(
    (children: React.ReactNode) => {
      if (isPreviewMode) {
        return <div>{children}</div>;
      }
      return children;
    },
    [isPreviewMode]
  );
  return (
    <Box overflow="visible" direction="row" style={isPreviewMode ? { position: 'relative' } : {}}>
      {getWrapper(
        <Box data-testid={`report-summary_subsidiary_${index}`} direction="row" width="10px">
          {isLastItem ? (
            <Box direction="row" height="13px" align="end">
              <Box height="13px" width="2px" background="border"></Box>
              <Box height="2px" width="8px" background="border"></Box>
            </Box>
          ) : (
            <Box
              direction="row"
              height="100%"
              align="start"
              style={isPreviewMode ? { position: 'absolute', top: 0, bottom: 0 } : {}}
            >
              <Box width="2px" height="100%" background="border"></Box>

              <Box direction="row" height="13px" align="end">
                <Box height="2px" width="8px" background="border"></Box>
              </Box>
            </Box>
          )}
        </Box>
      )}

      {getWrapper(
        <Box fill overflow="visible" direction="column" pad={{ bottom: 'spacing12' }}>
          {!isTotalModeLastItem && (
            <Text
              data-testid={`report-summary_subsidiary_${index}_total`}
              margin={{ bottom: 'spacing8', left: 'spacing4' }}
              weight={700}
            >
              {title}
            </Text>
          )}

          <ReportSummaryBaseTable
            subsidiaryIndex={index}
            isPreviewMode={isPreviewMode}
            isTotalModeLastItem={isTotalModeLastItem}
            key="key"
            rows={rows}
            headers={headers}
          />
        </Box>
      )}
    </Box>
  );
};

export default ReportSummaryBaseSubsidiary;
